import { DEFAULT_DELAY } from "@rothoblaas/design-system";
import { PaginationQueryWithFields } from "../types";

export const createLoadOptions = <T, K extends keyof T>(
  aborterRef: React.MutableRefObject<AbortController>,
  searchTermRef: React.MutableRefObject<string>,
  get: (query: PaginationQueryWithFields<Pick<T, K>>, signal: AbortSignal) => Promise<Pick<T, K>[]>,
  query?: PaginationQueryWithFields<Pick<T, K>>,
) => {
  const loadOptions = (inputValue: string): Promise<Pick<T, K>[]> => {
    aborterRef.current.abort();
    aborterRef.current = new AbortController();
    searchTermRef.current = inputValue;

    return new Promise<Pick<T, K>[]>((resolve, reject) => {
      setTimeout(async () => {
        if (searchTermRef.current == inputValue) {
          try {
            const items = await get(
              {
                limit: 5,
                ...query,
                q: inputValue,
                fields: query?.fields ?? [],
              },
              aborterRef.current.signal,
            );
            resolve(items ?? []);
          } catch (error) {
            console.error(error);
            reject(error);
          }
        } else {
          reject();
        }
      }, DEFAULT_DELAY);
    });
  };

  return loadOptions;
};
